export const ANALYTICS_CONSTANTS = {
    ANALYTICS_API_PATH: 'trip/online-check-in/api/v1/analytics',
    // Can't disable autoPageViewTracking so we add an infinite timeout delay
    AUTO_PAGE_VIEW_TRACKING_TIMING: 9999999
};
